export default __webpack_public_path__ + "static/media/uju.ddc2a323.jpg";